// Content helpers observe native variants; they never change product selection or the cart.
if (!customElements.get('astra-collar-fit-check')) {
  customElements.define('astra-collar-fit-check', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const input = this.querySelector('input');
      const button = this.querySelector('button');
      const result = this.querySelector('[data-fit-result]');
      if (!input || !button || !result) return;
      const fr = this.dataset.language === 'fr';
      const check = () => {
        const measurement = Number(input.value);
        if (!input.value.trim() || !Number.isFinite(measurement) || measurement <= 0) {
          result.textContent = fr ? 'Saisissez le tour de cou en centimètres.' : 'Enter the neck measurement in centimetres.';
          return;
        }
        const matches = [
          { name: fr ? 'Petit' : 'Small', min: 26, max: 36, width: '1.5' },
          { name: fr ? 'Moyen' : 'Medium', min: 36, max: 47, width: '2' },
          { name: fr ? 'Grand' : 'Large', min: 41, max: 59, width: '2.5' }
        ].filter(size => measurement >= size.min && measurement <= size.max);
        if (!matches.length) {
          result.textContent = fr
            ? 'Cette mesure est hors de nos plages de tailles. Demandez-nous conseil avant de commander.'
            : 'This measurement is outside our collar size ranges. Ask us for sizing help before ordering.';
          return;
        }
        result.textContent = matches.map(size => fr
          ? `${size.name} (largeur ${size.width.replace('.', ',')} cm)`
          : `${size.name} (${size.width} cm wide)`
        ).join(fr ? ' ou ' : ' or ') + (fr
          ? ' correspond à votre mesure. Vérifiez l’ajustement à la réception.'
          : ' covers your measurement. Check the fit when it arrives.');
      };
      button.addEventListener('click', check);
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); check(); }
      });
    }
  });
}
if (!customElements.get('astra-bed-fit-summary')) {
  customElements.define('astra-bed-fit-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.variantListener) return;
      let sizeRows;
      try { sizeRows = JSON.parse(this.querySelector('[data-bed-fit-variants]')?.textContent || '[]'); }
      catch { sizeRows = []; }
      const sizes = new Map(sizeRows.map(item => [String(item.id), item]));
      this.eventName = `variant:change:${this.dataset.sectionId}:${this.dataset.productId}`;
      this.variantListener = event => {
        const { variant, loading } = event.detail || {};
        this.setAttribute('aria-busy', loading ? 'true' : 'false');
        if (loading) return;
        if (!variant) { this.hidden = true; return; }
        const sizeRow = sizes.get(String(variant.id));
        const size = sizeRow?.size;
        if (size !== 'grande' && size !== 'standard') { this.hidden = true; return; }
        const grande = size === 'grande';
        this.hidden = false;
        this.querySelector('[data-fit-size]').textContent = sizeRow.label || (grande ? 'Grande' : 'Standard');
        this.querySelector('[data-fit-inside]').textContent = grande ? '75 × 54 cm' : '50 × 40 cm';
        this.querySelector('[data-fit-outside]').textContent = grande ? '95 × 70 cm' : '80 × 56 cm';
      };
      document.addEventListener(this.eventName, this.variantListener);
    }
    disconnectedCallback() {
      if (this.variantListener) document.removeEventListener(this.eventName, this.variantListener);
      this.variantListener = null;
    }
  });
}

if (!customElements.get('astra-matching-product-link')) {
  customElements.define('astra-matching-product-link', class extends HTMLElement {
    connectedCallback() {
      if (this.variantListener) return;
      const picker = document.querySelector(`kit-variant-picker[data-product-id="${this.dataset.sourceProductId}"]`);
      const link = this.closest('section')?.querySelector('[data-matching-product-link]');
      if (!picker || !link) return;
      let data;
      try { data = JSON.parse(this.querySelector('[data-matching-product-data]')?.textContent || '{}'); }
      catch { return; }
      // Liquid resolves stable source/target variant IDs and live availability.
      // Translated colour labels are presentation only.
      const sources = new Map((data.sourceVariants || []).map(item => [String(item.id), item]));
      this.eventName = `variant:change:${picker.dataset.sectionId}:${this.dataset.sourceProductId}`;
      this.variantListener = event => {
        const { variant, loading } = event.detail || {};
        if (loading) {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          return;
        }
        const target = variant ? sources.get(String(variant.id)) : undefined;
        link.href = target?.url || this.dataset.defaultUrl;
        link.removeAttribute('aria-disabled');
      };
      document.addEventListener(this.eventName, this.variantListener);
    }
    disconnectedCallback() {
      if (this.variantListener) document.removeEventListener(this.eventName, this.variantListener);
      this.variantListener = null;
    }
  });
}
